// 罗马尼亚语
const ro = {
  home: {
    home: 'Acasă',
    solutions: 'Soluții',
    support: 'Suport',
    news: 'Noutăți',
    aboutUs: 'Despre noi',
    contactUs: 'Contactați-ne',
    cgm: 'Dispozitiv de monitorizare continuă a glicemiei ( CGM )',
    download: 'Descărcări',
    helpCenter: 'Centru de ajutor',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Toate drepturile rezervate.',
    menu: 'Meniu',
    quickLinks: 'Linkuri rapide',
    contact: 'Contact',
    legal: 'Legal',
    termsUse: 'Termeni de utilizare',
    privacyPolicy: 'Politica de confidențialitate',
    portal: 'Portal utilizator',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'Email',
    subscribe: 'Abonați-vă',
    signUp: 'Înscrieți-vă pentru a primi cele mai recente noutăți',
    downloadApp: 'Descărcați aplicația',
    blogNews: 'Blog & Noutăți',
    latestArticles: 'Articole recente',
    viewAllArticles: 'Vezi toate articolele',
    empower: 'Împuternicește-ți parcursul către sănătate alături de noi',
    empowerList1Content:
      'Senzorul Hippo a făcut gestionarea diabetului fiului meu mult mai ușoară. Putem folosi HIPPOLINK pentru a vedea clar tiparele glicemiei sale și să ajustăm îngrijirea sa cu încredere. Ne oferă liniște sufletească.',
    empowerList1Name:
      'Petra N., Republica Cehă (mamă a unui copil cu diabet de tip 1)',
    empowerList2Content:
      'Recomandăm senzorul HIPPO pacienților de aici pentru performanța sa stabilă și durata mai lungă de purtare. Feedback-ul utilizatorilor a fost excelent, mai ales din partea celor care caută o opțiune mai accesibilă.',
    empowerList2Name: 'Dr. Luca B., Endocrinolog, Italia',
    empowerList3Content:
      'Am început să folosesc recent senzorul Hippo — este confortabil, precis, iar alertele m-au ajutat să evit hipoglicemia în timpul nopții. Foarte mulțumit de rezultate până acum.',
    empowerList3Name: 'Fahad A., Arabia Saudită (pacient cu diabet de tip 2)',
    reliable: 'Partenerul tău de încredere pentru gestionarea diabetului',
    hippoH1: 'HiPPO H1',
    challenges: 'Provocări',
    constant: 'Monitorizarea constantă a glicemiei',
    traditional:
      'Înțeparea tradițională a degetului pentru verificarea glicemiei poate fi dureroasă și incomodă',
    dataOverload: 'Supraîncărcare de date',
    managing:
      'Gestionarea datelor glicemiei din mai multe surse poate fi copleșitoare și dificil de interpretat',
    treatment: 'Ajustări ale tratamentului',
    accurately:
      'Determinarea cu precizie a acțiunilor corecte pe baza valorilor glicemiei poate fi complexă',
    lifestyle: 'Integrarea în stilul de viață',
    balancing:
      'Echilibrarea meselor, exercițiilor și medicației cu activitățile zilnice poate fi o provocare',
    hippoCan: 'Hippo Biosensors oferă',
    painless: 'Monitorizare nedureroasă și discretă',
    ourCgm:
      'Senzorul nostru oferă valori continue ale glicemiei fără necesitatea înțepării degetului',
    realTime: 'Date și informații în timp real',
    accessYour:
      'Accesați comod datele glicemiei pe smartphone, permițându-vă să vedeți tendințele și să luați decizii informate',
    personalized: 'Suport personalizat',
    ourCgmSys:
      'Alertele și reamintirile din aplicația Hippo BioSensors vă pot ajuta să rămâneți pe drumul corect al planului de tratament.',
    improved: 'Luarea deciziilor îmbunătățită',
    gain: 'Înțelegere mai profundă a modului în care organismul reacționează la evenimente, oferindu-vă posibilitatea de a compensa mai bine fluctuațiile glicemiei. Feedback-ul în timp real vă permite să ajustați mai eficient activitățile zilnice.',
    // about: 'Despre',
    companyProfile: 'Profilul companiei',
    banner1Title: 'Bine ați venit la Hippo Medical',
    banner1Content: 'În avangarda inovației senzorilor ( CGM )',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Stabilind noi standarde în tehnologia senzorilor ( CGM ).',
    banner3Content: 'Protecție glicemică non-stop.',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Lider în tehnologia senzorilor ( CGM )',
    // 错误提示
    subscribeSuccess: 'Abonare reușită',
    subscribeFailed: 'Abonare eșuată',
    invalidEmail: 'Adresă de e-mail invalidă',
  },
  cgm: {
    get banner1Title() {
      return ro.home.banner1Title;
    },
    get banner1Content() {
      return ro.home.banner4Content;
    },
    whyChoose: 'De ce să alegeți senzorul HiPPO',
    accurate: 'Precizie în care puteți avea încredere',
    accurateText:
      'Tehnologia enzimatică de a treia generație oferă o performanță mai bună',
    accurateText1: 'performanță stabilă și precisă',
    easyUse: 'Ușor de utilizat',
    easyUseText: '14 zile de monitorizare continuă',
    realTime: 'Monitorizare',
    realTimeText: 'Alerte în timp real pentru hipo- și hiperglicemie',
    realTimeText1:
      'Partajare în timp real a datelor cu membrii familiei și medicul',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Vă ține informat oriunde și oricând',
    withHippo: 'Cu aplicațiile și portalul HiPPO',
    smallSensors: 'Senzori mici, purtare confortabilă',
    agpReport:
      'Raportul AGP permite medicilor și utilizatorilor să capteze imediat informațiile cheie',
    unlimitedFollow:
      'Urmărirea nelimitată oferă medicilor posibilitatea de a gestiona mai mulți utilizatori',
    iWatchApp: 'Aplicație iWatch disponibilă',
    certified: 'Utilizare certificată pentru copii',
    loremIp:
      'Sistemul este validat clinic și certificat oficial pentru utilizarea la copii cu vârsta de 3 ani și peste, asigurând siguranță, precizie și confort pentru pacienții mai tineri. Cu o acuratețe dovedită și materiale delicate, prietenoase cu pielea,senzorul oferă o monitorizare de încredere a glicemiei pentru copii și adolescenți — sprijinind profesioniștii din sănătate în a oferi cu încredere o îngrijire a diabetului bazat pe date.',
  },
  news: {
    date: 'Dată',
    recommendedArticles: 'Articole recomandate',
  },
  support: {
    download: 'Ghiduri de descărcare',
    supportDown: 'Suport/Descărcări',
  },
  about: {
    // welcome: 'Bine ați venit la Hippo Medical',
    // covered: 'Țări acoperite',
    // patents: 'Brevete',
    // features: 'Caracteristici3',
    // ring: 'Inel',
    // apparently:
    // 'Un inel misterios care poate monitoriza parametri precum oxigenul din sânge, ritmul cardiac și somnul. Mai important, are o conexiune algoritmică cu senzorul  (CGM ) nostru. Lansare în 2026. Rămâneți aproape!',
    // cgmSky:
    //   'Un senzor ( CGM ) profesional conceput atât pentru utilizarea de către pacienți, cât și pentru nevoile clinice ale medicilor. Oferă precizie ridicată, un software ușor de utilizat și este alimentat de algoritmii Hippo Medical. Lansat în iunie 2025!',
    // smartWatch: 'Ceas inteligent',
    // byTheSame:
    //   'Un dispozitiv purtabil de monitorizare dinamică a tensiunii arteriale care poate urmări continuu presiunea sistolică, presiunea diastolică, presiunea arterială medie și altele, cu un algoritm dezvoltat de Hippo Medical. Lansare în 2026. Rămâneți aproape!',
    explore: 'Explorați',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPORE(409051)',
    zipCode: 'Cod poștal',
    emailCode: '409051',
    email: 'Email',
    emailText: 'info@hippodiabetes.com',
    name: 'Nume',
    company: 'Companie',
    message: 'Mesaj',
    phone: 'Telefon',
    submit: 'Trimite',
    // commingSoon: 'În curând',
    cpInfo1:
      'Hippo Medical este o companie globală MedTech, cu sediul central în Singapore, dedicată revoluționării managementului bolilor cronice prin biosenzori purtabili de nivel medical. Viziunea noastră este de a oferi monitorizare continuă și analiză avansată a datelor.',
    cpInfo2:
      'Prin dezvoltarea biosenzorilor de nouă generație și a unei platforme avansate de inteligență a datelor, ne propunem să transformăm diagnosticul și să deschidem calea către un viitor mai proactiv și personalizat.',
    submitFailed: 'Trimitere eșuată',
    get invalidEmail() {
      return ro.home.invalidEmail;
    },
    fillAllFields: 'Vă rugăm să completați acest câmp	',
  },
  download: {
    language: 'Limbă',
    product: 'Produs',
    unit: 'Unitate',
    fetchFailed: 'Obtinere eșuată',
  },
  help: {
    search: 'Căutare',
    support: 'Suport/Centru de ajutor/H1 CGM',
    source: 'Resurse online HiPPO H1 CGM',
    viewAll: 'Vezi toate',
    insert: 'Cum să inserați senzorul H1',
    setUp: 'Cum să configurați aplicația H1',
    faq: 'Întrebări frecvente HiPPO H1 CGM',
    freq: 'Întrebări frecvente',
    noData: 'Nu s-a găsit conținut..',
    searchKeys: {
      warmUp: 'Faza de încălzire a eșuat',
      waterLeakage: 'Scurgeri de apă',
      lowGlucose: 'Date glicemie scăzută',
      cannotPair: 'Nu pot împerechea dispozitivul cu smartphone-ul meu',
    },
  },
  faq: {
    faq: 'Întrebări frecvvente (FAQ)',
    general: 'Întrebări generale',
    need: 'Aveți nevoie de ajutor pentru ceva？',
    here: 'Iată cele mai frecvente întrebări',
    technical: 'Întrebări tehnice',
  },
  lang: {
    chooseCountry: 'Alegeți țara/regiunea',
    northAmerica: 'America de Nord',
    southAmerica: 'America de Sud',
    europe: 'Europa',
    africa: 'Africa',
    asia: 'Asia',
    oceania: 'Oceania',
    other: 'Altele',
  },
  aboutMap: {
    suzhou: {
      name: 'Suzhou, China',
      subName: 'Unitate de producție',
      hovData:
        'Sediul central global R&D/Centru de date Birou de vânzări acoperind Asia și Australia',
    },
    dubai: {
      name: 'Dubai',
      subName: 'Birou regional',
      hovData: 'Echipa de vânzări HQ Asia de Sud-Est',
    },
    singapore: {
      name: 'Singapore',
      subName: 'Sediul central',
      hovData: 'Echipa de vânzări Asia de Sud-Est',
    },
    sanFrancisco: {
      name: 'San Francisco, SUA',
      subName: 'Birou regional',
      hovData: 'Echipa de vânzări HQ America de Nord',
    },
    barcelona: {
      name: 'Barcelona',
      subName: 'Birou de vânzări',
      hovData:
        'Sediul central global R&D/Centru de date Birou de vânzări acoperind Asia și Australia',
    },
  },
};
export default ro;
